import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ArrowRightIcon } from 'lucide-react';
const SHOPIFY_CART_URL = 'https://www.nextlevelvital.com/cart/47874715320564:1';
const CURRENT_PRICE = 6.36;
interface CTAButtonProps {
  className?: string;
  redirectToCart?: boolean;
}
export function CTAButton({
  className = '',
  redirectToCart = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (redirectToCart) {
      // Track AddToCart event in Meta Pixel
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart', {
          content_name: 'Los 7 Síntomas Silenciosos del Vacío Emocional Femenino',
          content_type: 'product',
          content_ids: ['47874715320564'],
          value: CURRENT_PRICE,
          currency: 'USD'
        });
      }
      // Redirect to Shopify cart
      window.location.href = SHOPIFY_CART_URL;
    } else {
      // Scroll to pricing section
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 4px 20px rgba(201,169,110,0.3)', '0px 4px 40px rgba(201,169,110,0.6)', '0px 4px 20px rgba(201,169,110,0.3)']
  }} transition={{
    boxShadow: {
      repeat: Infinity,
      duration: 4,
      ease: 'easeInOut'
    },
    scale: {
      duration: 0.3
    },
    y: {
      duration: 0.3
    }
  }} className={`group relative bg-gold text-burgundy-dark font-bold py-5 px-6 md:px-10 rounded-full shadow-xl transition-all duration-500 text-center flex flex-col items-center justify-center w-full max-w-xl mx-auto overflow-hidden ${className}`} data-id="element-276">
      {/* Shimmer Effect */}
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_3s_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12 z-10" data-id="element-277"></div>

      {/* Hover Glow Background */}
      <div className="absolute inset-0 rounded-full bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-500 z-0" data-id="element-278"></div>

      <span className="relative z-20 text-base md:text-lg lg:text-xl mb-2 flex items-center gap-2" data-id="element-279">
        ¡QUIERO RECUPERAR MI CHISPA AHORA!
        <ArrowRightIcon className="w-5 h-5 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-280" />
      </span>

      <span className="relative z-20 text-xs md:text-sm font-medium opacity-80 flex items-center gap-1.5" data-id="element-281">
        <LockIcon className="w-3.5 h-3.5" data-id="element-282" /> Compra segura. Descarga
        instantánea.
      </span>
    </motion.button>;
}